<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('操作员')">
              <a-select v-model="queryParam.operatorName" :placeholder="$t('请选择操作员')">
                <a-select-option v-for="data in userList" :key="data.id" :value="data.username">
                  {{data.username}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('审核员')">
              <a-select v-model="queryParam.auditorName" :placeholder="$t('请选择审核员')">
                <a-select-option v-for="data in userList" :key="data.id" :value="data.username">
                  {{data.username}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('audit_user_link')">{{ $t('导出') }}</a-button>
      <!--
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange"
        >

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record" class="action">

          <!--<a @click="handleEdit(record)">编辑</a>-->
          <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
            <a :disabled="record.isStart== 1">{{ $t('删除') }}</a>
          </a-popconfirm>
          <a-popconfirm :title="$t('确定启用吗?')" @confirm="() => handleEditStart(record,1)">
            <a v-if="record.isStart==0">{{ $t('启用') }}</a>
          </a-popconfirm>
          <a-popconfirm :title="$t('确定关闭启用吗?')" @confirm="() => handleEditStart(record,0)">
            <a v-if="record.isStart==1">{{ $t('关闭启用') }}</a>
          </a-popconfirm>

          <!--
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          -->
        </span>

      </a-table>
    </div>

    <audit-user-link-modal ref="modalForm" @ok="modalFormOk"></audit-user-link-modal>
  </a-card>
</template>

<script>

  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import AuditUserLinkModal from './modules/AuditUserLinkModal'
  import { listSize } from '@/utils/util'
  import { getAction,putAction } from '@/api/manage'
  import { mapGetters } from 'vuex'

  export default {
    name: 'AuditUserLinkList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      AuditUserLinkModal
    },
    data () {
      return {
        description: this.$t('audit_user_link管理页面'),
        url: {
          list: "/auditprocess/auditUserLink/list",
          delete: "/auditprocess/auditUserLink/delete",
          deleteBatch: "/auditprocess/auditUserLink/deleteBatch",
          exportXlsUrl: "/auditprocess/auditUserLink/exportXls",
          importExcelUrl: "auditprocess/auditUserLink/importExcel",
          edit: '/auditprocess/auditUserLink/edit',
          user: "/sys/user/departUserList",  //操作员列表
          deptList: "/sys/sysDepart/getDepartName"
        },
        dictOptions:{},
        userList:[],  
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime',

          },
          {
            title: this.$t('审核员'),
            align:"center",
            dataIndex: 'auditorName'
          },
          {
            title: this.$t('操作员'),
            align:"center",
            dataIndex: 'operatorName'
          },
          {
            title: this.$t('创建人'),
            align:"center",
            dataIndex: 'createBy'
          },

          {
            title: this.$t('是否启用'),
            align:"center",
            dataIndex: 'isStart',
            customRender: (t,r,index) => {
              return t == 1? this.$t('启用'): this.$t('未启用');
            }
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    created() {  //入口
      //this.getParams()
      this.queryUserList()
    },
    methods: {
      ...mapGetters(["userInfo"]),
      initDictConfig(){
      },
      queryUserList() { //操作员请求
        getAction(this.url.deptList, {pageNo: 1,pageSize: 1,orgCode: this.userInfo().orgCode}).then((res) => {
          if(res.success&&res.result.id){
            let params = {}
            params.pageNo = 1;
            params.pageSize = listSize;
            console.log(this.userInfo())
            params.depId = res.result.id;
            getAction(this.url.user, params).then((res) => {
              if(res.success){
                this.userList = res.result.records;
              }
            }) 
          }
        })
      },
      handleEditStart(record,isStart) {
        putAction(this.url.edit, {isStart:isStart,id:record.id}).then((res) => {
          if (res.success) {
            this.$message.success(res.message);
            this.loadData();
          } else {
            this.$message.warning(res.message);
          }
        });
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>